import React, { Component } from "react";
import "./style/appointmentScheduled.css";
import moment from "moment";
import ReScheduledModal from "./ReScheduledModal";
import ReScheduledConfirmModal from "./ReScheduledConformModal";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";

class AppointmentScheduled extends Component {
  state = {
    isRescheduleClicked: false,
    messageSentModal: false,
  };
  userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  openView = () => {
    this.setState({ isRescheduleClicked: true });
  };
  handleClose = () => {
    this.setState({ isRescheduleClicked: false });
  };
  instantRescheduleAppointment = () => {
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/reschedule-appointment",
      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: {
        appointment_id: this.props.appointmentId,
        doctor_id: this.userId,
        consultation_type: "instant_consultation",
      },
    })
      .then((res) => {
        if (res.data.statusCode === 200) {
          this.setState({
            isRescheduleClicked: false,
            messageSentModal: true,
          });
        }
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };
  closePopup = () => {
    this.setState({ messageSentModal: false });
    this.props.closeBookedCard();
  };

  render() {
    return (
      <div className="appointment_scheduled_cont">
        <div className="appointment_scheduled_heading">
          <h6>Appointment Scheduled</h6>
        </div>
        <div className="appointment_scheduled_content_text">
          <p>
            Your instant consultation is overlapping with the below scheduled
            appointment
          </p>
        </div>
        <div className="appointment_scheduled_details">
          <p>
            Patient Name : <span> {this.props.patientName}</span>
          </p>
          <p>
            Time Slot :{" "}
            <span>
              {" "}
              {moment(this.props.startTime, "hh:mmZ").format("hh:mm A")}{" "}
            </span>{" "}
            -{" "}
            <span>
              {" "}
              {moment(this.props.endTime, "hh:mmZ").format("hh:mm A")}
            </span>
          </p>
        </div>
        <div className="appointment_scheduled_btn_cont">
          <button
            className="reschedule_btn"
            onClick={() => {
              this.openView();
            }}
          >
            Reschedule Appointment
          </button>
          <button className="Continue_btn" onClick={this.props.closeBookedCard}>
            Okay, Continue
          </button>
        </div>

        <ReScheduledModal
          show={this.state.isRescheduleClicked}
          handleClose={() => {
            this.handleClose();
          }}
          rescheduleData={this.instantRescheduleAppointment}
        />
        <ReScheduledConfirmModal
          show={this.state.messageSentModal}
          closeReschedule={() => {
            this.closePopup();
          }}
        />
      </div>
    );
  }
}

export default AppointmentScheduled;
